'use strict';

var BaseRouter = require('commons/routers/Base');

module.exports = BaseRouter.extend({
    noSetupRequiredRoutes: [
        'dashboard',
        'settings',
        'settings/company',
        'personalSettings'
    ],

    initialize: function(options) {
        options = _.defaults(options || {}, {
            el: null
        });

        this.el = options.el;

        BaseRouter.prototype.initialize.apply(this, arguments);
    },

    route: function(route, name, callback) {
        var f;

        if (!callback) {
            callback = this[name];
        }

        f = function() {
            if (typeof callback === 'function') {
                callback.apply(this, arguments);
            }
        };

        return BaseRouter.prototype.route.apply(this, [route, name, f]);
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Base.js